import encodeurl from 'encodeurl';
import { BYPASS_URL_RESPONSE_VALIDATION_FIELD } from 'modules/campaigns/modules/creative-creator/components/UrlList/UrlValidatedInput';
import { updateLibraryCreative } from './updateLibraryCreative';

export const updateLibraryCreativeUrlCellEditor = (newValue, creative) => dispatch => {
    const creativeChange = {
        url: encodeurl(newValue.url),
        [BYPASS_URL_RESPONSE_VALIDATION_FIELD]: creative[BYPASS_URL_RESPONSE_VALIDATION_FIELD],
    };

    dispatch(updateLibraryCreative(creativeChange, creative));
};
